// export const API_URL = 'http://127.0.0.1:8000/api'; // development
export const API_URL = 'https://movies-admin-panel-backend.onrender.com/api'; // production